var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasMatchingWorkingDurations)?_c('extra-info',{staticClass:"extra-info_warning tw--ml-3",attrs:{"icon":"exclamation-solid"}},[_c('div',{staticClass:"tw-p-4 tw-w-48"},[_vm._v(" The hours per working day does not align with the working week schedule provided. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }